import * as ROUTES from '../common/routes';
import React, { useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import frameImg from '../assets/img/add_image_bg.png';
import uploadIcon from '../assets/img/add_choose_image.png';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';

interface IProps {
  onImageAdd: (image) => void;
  info?: string;
}

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      dropZoneContainerStyle: {
        position: 'relative',
        width: '100%',
        height: 'auto',
        display: 'flex',
        justifyContent: 'center',
      },
      frameContainerStyle: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        cursor: 'pointer',
        margin: '-10px -10px 0 0',
        '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
        outline: 'none !important',
      },
      frameStyle: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      uploadIconContainerStyle: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        maxWidth: '400px',
        color: COLORS.appBrown,
        fontSize: '14px',
        fontFamily: FONTS.roboto,
        padding: '0 20px',
      },
      uploadIconStyle: {
        width: '47px',
        height: '47px',
        marginBottom: '20px',
      },
      previewStyle: {
        position: 'absolute',
        width: '90%',
        height: '90%',
        objectFit: 'contain',
      },
      [`@media (max-width: 800px)`]: {
        frameContainerStyle: {
          margin: 0,
        },
      },
    })
);

const DropZoneContainer = ({ onImageAdd, info }: IProps): JSX.Element => {
  const classes = useStyles();

  const [file, setFile] = useState(null);

  const onDrop = useCallback((acceptedFiles) => {
    // setFiles(acceptedFiles.map(file => Object.assign(file, {
    //   preview: URL.createObjectURL(file)
    // })));
    const currentFile = acceptedFiles[0];
    // setFile(Object.assign(currentFile, {
    //   preview: URL.createObjectURL(currentFile)
    // }));
    onImageAdd(currentFile);
  }, []);

  // useEffect(() => () => {
  //   // Make sure to revoke the data uris to avoid memory leaks
  //   // files.forEach(file => URL.revokeObjectURL(file.preview));
  //   URL.revokeObjectURL(file.preview);
  // }, [file]);

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({
      onDrop,
      maxFiles: 1,
      maxSize: 31457280,
      accept: 'image/*,.pdf',
    });

  const getType = () => {
    if (acceptedFiles?.length) {
      return acceptedFiles[0].type;
    }

    return null;
  };

  const type = getType();

  const getUpload = () => {
    if (type === 'application/pdf' || type === 'image/tiff') {
      const fileName = acceptedFiles?.[0]?.name;

      return (
        <div
          className={classes.uploadIconContainerStyle}
        >{`Aušupielādēts: ${fileName}`}</div>
      );
    }

    if (type?.includes('image/')) {
      const previewUrl = URL.createObjectURL(acceptedFiles[0]);

      return <img src={previewUrl} className={classes.previewStyle} />;
    }

    return (
      <div className={classes.uploadIconContainerStyle}>
        <img className={classes.uploadIconStyle} src={uploadIcon} alt="" />
        {info}
      </div>
    );
  };

  return (
    <div className={classes.dropZoneContainerStyle}>
      <div {...getRootProps()} className={classes.frameContainerStyle}>
        <input {...getInputProps()} />
        <img className={classes.frameStyle} src={frameImg} alt="" />
        {getUpload()}
      </div>
      {/* {
        isDragActive ?
          <p>Drop the files here ...</p> :
          <p>Drag 'n' drop some files here, or click to select files</p>
      } */}
    </div>
  );
};

export default DropZoneContainer;
